function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "linearGradient1475",
  x1: 151,
  x2: 112,
  y1: 192.4,
  y2: 137.3,
  gradientTransform: "matrix(.5625 0 0 .568 -3.808 1.516)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#ffd43b",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#ffe873",
  offset: 1
})), React.createElement("linearGradient", {
  id: "linearGradient1478",
  x1: 26.65,
  x2: 135.7,
  y1: 20.6,
  y2: 114.4,
  gradientTransform: "matrix(.5625 0 0 .568 -3.808 1.516)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#5a9fd4",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#306998",
  offset: 1
})), React.createElement("radialGradient", {
  id: "radialGradient1480",
  cx: 61.52,
  cy: 132.3,
  r: 29.04,
  gradientTransform: "matrix(1.749e-8 -.2399 1.055 3.792e-7 -72.52 155.7)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#b8b8b8",
  stopOpacity: 0.498,
  offset: 0
}), React.createElement("stop", {
  stopColor: "#7f7f7f",
  stopOpacity: 0,
  offset: 1
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "m66.1 13.22c-4.584 0.0213-8.961 0.4122-12.81 1.094-11.35 2.005-13.41 6.2-13.41 13.94v10.22h26.81v3.406h-36.88c-7.792 0-14.62 4.684-16.75 13.59-2.462 10.21-2.571 16.59 0 27.25 1.906 7.938 6.458 13.59 14.25 13.59h9.219v-12.25c0-8.85 7.657-16.66 16.75-16.66h26.78c7.455 0 13.41-6.138 13.41-13.62v-25.53c0-7.266-6.13-12.72-13.41-13.94-4.606-0.7667-9.385-1.115-13.97-1.094zm-14.5 8.219c2.77 0 5.031 2.299 5.031 5.125-2e-6 2.816-2.262 5.094-5.031 5.094-2.779-1e-6 -5.031-2.277-5.031-5.094-1e-6 -2.826 2.252-5.125 5.031-5.125z",
  fill: "url(#linearGradient1478)"
}), React.createElement("path", {
  d: "m96.82 41.88v11.91c0 9.231-7.826 17-16.75 17h-26.78c-7.336 0-13.41 6.278-13.41 13.62v25.53c0 7.266 6.319 11.54 13.41 13.63 8.487 2.496 16.63 2.947 26.78 0 6.75-1.954 13.41-5.888 13.41-13.63v-10.22h-26.78v-3.406h40.19c7.792 0 10.7-5.435 13.41-13.59 2.799-8.399 2.68-16.48 0-27.25-1.926-7.757-5.604-13.59-13.41-13.59zm-15.06 64.66c2.779 0 5.031 2.277 5.031 5.094-2e-6 2.826-2.252 5.125-5.031 5.125-2.77 0-5.031-2.299-5.031-5.125 2e-6 -2.816 2.262-5.094 5.031-5.094z",
  fill: "url(#linearGradient1475)"
}), React.createElement("ellipse", {
  cx: 67,
  cy: 140.9,
  rx: 35.93,
  ry: 6.967,
  fill: "url(#radialGradient1480)",
  opacity: 0.4438
}));

var SvgPython = function SvgPython(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 120 140",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPython, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/python.9ebdd662.svg";
export { ForwardRef as ReactComponent };